cb.define([], function () {
  var AA_aa_billTemplatelist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
    	viewmodel.getGridModel().setShowCheckbox(false);//设置复选框不显示
	    viewmodel.getGridModel().on('beforeLoad',function(data)
	    {
		    if (data.condition)
		     {
			      var commonVOs=data.condition.commonVOs;
			      var keyJson = {value1: "0", itemName: "templateType"};
			      commonVOs.push(keyJson);
		     }
	    });
    }
  }
  try {
    module.exports = AA_aa_billTemplatelist_VM_Extend;
  } catch (error) {
  }
  return AA_aa_billTemplatelist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_billTemplatelist_VM.Extend.js